import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { IModel } from '../../../core/service/base/data.service';
import { RentInvoicingOrderStatus, RentInvoicingOrderStatusText } from './rent-invoicing-order-status';

export class RentInvoicingOrderListItem extends ModelBase implements IModel {
  createdByName: string;
  caption: string;
  orderedAt: Date;
  startedAt: Date;
  completedAt: Date;
  errorMessage: string;
  autoAttest: boolean;
  scheduled: boolean;
  dueFrom: LocalDate;
  dueTo: LocalDate;
  invoiceCount: number;
  attestedInvoiceCount: number;
  status: RentInvoicingOrderStatus;
  get statusText(): string {
    return RentInvoicingOrderStatusText(this.status);
  }
}
